import React from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';
import { EVENT_POSITION_FOR_ARCHIVE_ORDERS } from '../../../../../../shop/constants/tracker';
import DifferenceValue from '../../../../components/DifferenceValue';
import OrderNumberLink from '../../../../components/OrderNumberLink';
import { useAppContext } from '../../../../context/appContext';

const ORDER_TYPE_RETURN = 'return';
const REMARKS_BULK_IMPORTED = 'bulk_imported';

const TableRenderComponent = ({ id, item }) => {
  const { t } = useTranslation();
  const { slFeatureService } = useAppContext();
  const hasOrderArchiveTestingCrm = slFeatureService.hasFeature(
    'order_archive_testing_crm',
  );
  const getManualCreditI18nKey = (orderType) => {
    if (hasOrderArchiveTestingCrm) {
      return 'store_credits.fields.revert_credit.order';
    }
    if (orderType === ORDER_TYPE_RETURN) {
      return 'store_credits.fields.revert_credit.return';
    }
    return 'store_credits.fields.revert_credit';
  };

  const getReturnOrderRevertI18nKey = () => {
    if (hasOrderArchiveTestingCrm) {
      return 'store_credits.fields.revert_credit.order';
    }
    return 'store_credits.fields.revert_credit.return_order_revert';
  };

  const {
    created_at,
    type,
    order_id,
    order_type,
    order_number,
    return_order_id,
    return_order_number,
    remarks,
    value,
    end_at,
    is_redeem,
  } = item;
  switch (id) {
    case 'created_at':
      return dayjs(created_at).format('YYYY/MM/DD h:mma');
    case 'remarks':
      switch (type) {
        case 'manual_credit':
          if ((order_id || '').length > 0) {
            return (
              <div className="member-center__list-item-remark">
                <span>{t(getManualCreditI18nKey(order_type))}</span>
                <OrderNumberLink
                  createdAt={created_at}
                  href={`/orders/${order_id}`}
                  orderId={order_id}
                  orderNumber={order_number}
                  position={
                    EVENT_POSITION_FOR_ARCHIVE_ORDERS.MEMBER_CENTER_CREDIT_HISTORY
                  }
                />
              </div>
            );
          }

          return remarks === REMARKS_BULK_IMPORTED
            ? t('store_credits.bulk_imported')
            : remarks;
        case 'applied_credit':
          return (
            <div className="member-center__list-item-remark">
              <span>{t('store_credits.fields.order_prefix')}</span>
              <OrderNumberLink
                createdAt={created_at}
                href={`/orders/${order_id}`}
                orderId={order_id}
                orderNumber={order_number}
                position={
                  EVENT_POSITION_FOR_ARCHIVE_ORDERS.MEMBER_CENTER_CREDIT_HISTORY
                }
              />
            </div>
          );
        case 'auto_reward':
          return (
            <div className="member-center__list-item-remark">
              <span>{t('store_credits.fields.auto_reward_prefix')}</span>
              <OrderNumberLink
                createdAt={created_at}
                href={`/orders/${order_id}`}
                orderId={order_id}
                orderNumber={order_number}
                position={
                  EVENT_POSITION_FOR_ARCHIVE_ORDERS.MEMBER_CENTER_CREDIT_HISTORY
                }
              />
              <span>{t('store_credits.fields.auto_reward')}</span>
            </div>
          );
        case 'order_split_revert':
          return (
            <div className="member-center__list-item-remark">
              <span>{t('store_credits.fields.revert_credit.order_split')}</span>
              <OrderNumberLink
                createdAt={created_at}
                href={`/orders/${order_id}`}
                orderId={order_id}
                orderNumber={order_number}
                position={
                  EVENT_POSITION_FOR_ARCHIVE_ORDERS.MEMBER_CENTER_CREDIT_HISTORY
                }
              />
            </div>
          );
        case 'order_edit_revert':
          return (
            <div className="member-center__list-item-remark">
              <span>{t('store_credits.fields.revert_credit.order_edit')}</span>
              <OrderNumberLink
                createdAt={created_at}
                href={`/orders/${order_id}`}
                orderId={order_id}
                orderNumber={order_number}
                position={
                  EVENT_POSITION_FOR_ARCHIVE_ORDERS.MEMBER_CENTER_CREDIT_HISTORY
                }
              />
            </div>
          );
        case 'product_review_reward':
          return (
            <div className="member-center__list-item-remark">
              <Trans
                i18nKey="store_credits.fields.product_review_reward"
                components={{
                  a: (
                    <OrderNumberLink
                      createdAt={created_at}
                      href={`/orders/${order_id}`}
                      orderId={order_id}
                      orderNumber={order_number}
                      position={
                        EVENT_POSITION_FOR_ARCHIVE_ORDERS.MEMBER_CENTER_CREDIT_HISTORY
                      }
                    />
                  ),
                }}
              />
            </div>
          );
        case 'return_order_revert':
          return (
            <div className="member-center__list-item-remark">
              <span>{t(getReturnOrderRevertI18nKey())}</span>
              <OrderNumberLink
                createdAt={created_at}
                href={`/return_orders/${return_order_id}`}
                orderId={return_order_id}
                orderNumber={return_order_number}
                position={
                  EVENT_POSITION_FOR_ARCHIVE_ORDERS.MEMBER_CENTER_CREDIT_HISTORY
                }
              />
            </div>
          );
        default:
          return <div>{t(`store_credits.fields.${type}`)}</div>;
      }
    case 'value':
      return <DifferenceValue isMinus={is_redeem} value={value} />;
    case 'expire_at':
      if (is_redeem) {
        return '-';
      }
      if (end_at) {
        return dayjs(end_at).format('YYYY/MM/DD');
      }
      return t('store_credits.fields.never_expires');
    case 'credit_balance':
      return item.credit_balance;
    default:
      return null;
  }
};

TableRenderComponent.propTypes = {
  id: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  item: PropTypes.object.isRequired,
};

export default TableRenderComponent;
